import React, {ChangeEventHandler, FC} from "react"
import {useFormData} from "../../states/FormData"
import TextInput from "../elements/TextInput"
import FlexDiv from "../elements/FlexDiv";
import FlexTwoCol from "../elements/FlexTwoCol";
import styled from "styled-components";

const Step5: FC = () => {

    const {setFormData, name, email, email_contact, newsletter} = useFormData()

    //@ts-ignore
    const changeHandler: ChangeEventHandler<HTMLInputElement> = (e) => setFormData(e.target.name, e.target.value)

    const StyledInput = styled.input.attrs({ type: 'checkbox' })`
    position: relative;
    left: 15px;
    top: -4px;
    z-index: 0;
    -webkit-appearance: none !important;
    & + label {
        font-size: 1rem;
    }
    & + label::before {
        width: 20px;
        height: 20px;
        border-radius: 5px;
        background-color: #F7F1ED;
        display: block;
        content: "";
        float: left;
        margin-right: 5px;
        z-index: 5;
        position: relative;
        top: 5px;
    }
    &:checked+label::before {
        box-shadow: inset 0px 0px 0px 3px #F7F1ED;
        background-color: #3B5049;
    }
    `;

    return (
        <>
            <span className={"survey-heading"}>Wie können wir dich erreichen?</span>
            <FlexDiv>
                <FlexTwoCol>
                    <TextInput name={"name"} value={name} onChange={changeHandler} label={"Dein Name"} />
                    <TextInput name={"email"} value={email} onChange={changeHandler} label={"Deine E-Mail"}/>
                </FlexTwoCol>
                <FlexTwoCol>

                    <StyledInput
                        type="checkbox"
                        name={"email_contact"}
                        value={"1"}
                        checked={email_contact}
                        onChange={() => setFormData("email_contact", !email_contact)}
                        id={"email_contact"}
                    />
                    <label htmlFor="email_contact">
                        &nbsp;Hiermit bestätige ich, dass JUNO Nutrition mich zur Beantwortung meiner Fragen per E-Mail kontaktieren darf.
                    </label>
                    <br/>
                    <StyledInput
                        type="checkbox"
                        name={"newsletter"}
                        value={"1"}
                        checked={newsletter}
                        onChange={() => setFormData("newsletter", !newsletter)}
                        id={"newsletter"}
                    />
                    <label htmlFor="newsletter">
                        &nbsp;Ja, ich möchte als Erstes über Neuigkeiten und den Launch von JUNO Nutrition informiert werden.
                    </label>
                    <br/>
                    <small><strong>Rechtlicher Hinweis:</strong> Bitte beachte, dass die Informationen, die wir bereitstellen, nicht als medizinische Beratung oder Behandlung zu verstehen sind. Unsere Antworten dienen ausschließlich zu Informationszwecken und sollten nicht als Ersatz für professionelle medizinische Beratung oder Diagnose angesehen werden. Bitte konsultiere immer einen qualifizierten Arzt oder eine qualifizierte Ärztin, bevor du irgendwelche medizinischen Entscheidungen triffst oder Maßnahmen ergreifst. Wir übernehmen keine Haftung für Schäden oder Verluste, die durch die Verwendung der von uns bereitgestellten Infor-mationen entstehen. Es wurde kein Beratungsverhältnis aufgebaut.</small>
                </FlexTwoCol>
            </FlexDiv>
        </>
    )
}

export default Step5